"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDayPicker = require("react-day-picker");
var _dates = require("../../utils/dates");
var _locale = require("date-fns/locale");
var _styles = require("./styles");
var _Text = _interopRequireDefault(require("../Text"));
var _util = require("./util");
var _CalendarEvent = _interopRequireDefault(require("./CalendarEvent"));
var _CalendarSmallEvent = _interopRequireDefault(require("./CalendarSmallEvent"));
var _format = require("../../utils/format");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Calendar = ({
  month,
  small,
  events
}) => {
  const renderDay = ({
    day
  }) => {
    return small ? renderSmall(day) : renderNormal(day);
  };
  const renderSmall = day => {
    const date = day.date.getDate();
    const dayEvents = events && (0, _util.getEventForDay)(events, day.date);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CalendarSmallCell, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CalendarSmallDate, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
          semibold: day.date.getMonth() === month.getMonth(),
          subtle: day.date.getMonth() !== month.getMonth(),
          children: [date, date === 1 && !small ? ' ' + _dates.MONTHS_SHORT[day.date.getMonth()] : '']
        })
      }), dayEvents && dayEvents.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarSmallEvent.default, {
        events: dayEvents
      })]
    });
  };
  const renderNormal = day => {
    const date = day.date.getDate();
    const dayEvents = events && (0, _util.getEventForDay)(events, day.date);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CalendarCell, {
      className: "rdp-cell",
      subtle: day.date.getDay() === 6 || day.date.getDay() === 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CalendarDate, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
          semibold: day.date.getMonth() === month.getMonth(),
          subtle: day.date.getMonth() !== month.getMonth(),
          children: [date, date === 1 ? ' ' + _dates.MONTHS_SHORT[day.date.getMonth()] : '']
        })
      }), dayEvents && dayEvents.length > 0 && dayEvents.map((e, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarEvent.default, {
        event: e
      }, i))]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
    small: small,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDayPicker.DayPicker, {
      disableNavigation: true,
      month: month,
      components: {
        Day: renderDay
      },
      hideNavigation: true,
      pagedNavigation: false,
      locale: _locale.nb,
      weekStartsOn: 1,
      showWeekNumber: true,
      showOutsideDays: true,
      "aria-label": `Kalender for ${(0, _format.getFormattedDate)(month, _dates.mmYYYY)}`
    })
  });
};
var _default = exports.default = Calendar;